import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { canonicalMunicipalitySlug, permanentRedirect } from "@/lib/legacyRedirects";


/** Gamla kommunsidor under /spotpris – permanent omdirigering till /elpriser. */
export const Route = createFileRoute("/spotpris/$slug")({
  head: () => seoHead("/spotpris/$slug"),
  beforeLoad: ({ params }) =>
    permanentRedirect(`/elpriser/${canonicalMunicipalitySlug(params.slug ?? "")}`),
});
